import { appThemes } from "../env";
import { color, theme } from "../components/templates/ui";
export { appThemes };
export const appStyles = {
    invoned: {
        name: "invoned",
        accent: theme.invoned.accent.base,
        primary: theme.invoned.primary.base,
        primaryHover: theme.invoned.primary.hover,
        secondary: theme.invoned.secondary.base,
        secondaryHover: theme.invoned.secondary.hover,
        tertiary: theme.invoned.tertiary.base,
        tertiaryHover: theme.invoned.tertiary.hover,
        quaternary: theme.invoned.quaternary.base,
        quaternaryHover: theme.invoned.quaternary.hover,
        ideal: theme.invoned.ideal.base,
        idealHover: theme.invoned.ideal.hover,
        textBase: theme.invoned.text.base,
        textLight: theme.invoned.text.light,
        textDark: theme.invoned.text.dark,
        grayDark: theme.invoned.gray.dark,
        grayBase: theme.invoned.gray.base,
        grayLight: theme.invoned.gray.light,
        border: theme.invoned.border.base,
        borderHover: theme.invoned.border.hover,
        fontBase: theme.invoned.font.base,
        fontHead: theme.invoned.font.head,
        overlay: "rgba(39, 87, 107, 0.6)",
        logo: "/img/invoned-logo.png",
        checkbox: theme.invoned.tertiary.base,
        dock: theme.invoned.gray.base,
        link: theme.invoned.link.base,
        linkHover: theme.invoned.link.hover,
        background: theme.invoned.gray.base,
        backgroundMobile: theme.invoned.text.base,
        languageToggle: color.body.base,
    },
};
export const baseAppStyle = {
    name: "inkassier",
    primary: theme.inkassier.primary.base,
    primaryHover: theme.inkassier.primary.hover,
    secondary: theme.inkassier.secondary.base,
    secondaryHover: theme.inkassier.secondary.hover,
    tertiary: theme.inkassier.tertiary.base,
    tertiaryHover: theme.inkassier.tertiary.hover,
    quaternary: theme.inkassier.quaternary.base,
    quaternaryHover: theme.inkassier.quaternary.hover,
    ideal: theme.inkassier.ideal.base,
    idealHover: theme.inkassier.ideal.hover,
    textBase: theme.inkassier.text.base,
    textLight: theme.inkassier.text.light,
    textDark: theme.inkassier.text.dark,
    grayDark: theme.inkassier.gray.dark,
    grayBase: theme.inkassier.gray.base,
    grayLight: theme.inkassier.gray.light,
    border: theme.inkassier.border.base,
    borderHover: theme.inkassier.border.hover,
    fontBase: theme.inkassier.font.base,
    fontHead: theme.inkassier.font.head,
    overlay: "rgba(0, 40, 86, 0.6)",
    logo: "/img/inkassier-logo.png",
    checkbox: theme.inkassier.primary.base,
    dock: theme.inkassier.primary.base,
    link: theme.inkassier.link.base,
    linkHover: theme.inkassier.link.hover,
    background: theme.inkassier.gray.base,
    backgroundMobile: theme.inkassier.text.base,
    languageToggle: theme.inkassier.tertiary.base,
};
